export enum AmplitudePageViewProperty {
    PAGE_DOMAIN = "[Amplitude] Page Domain",
    PAGE_LOCATION = "[Amplitude] Page Location",
    PAGE_PATH = "[Amplitude] Page Path",
    PAGE_URL = "[Amplitude] Page URL",
}

export const AMPLITUDE_CONFIG = {
    redactedValue: "[REDACTED]",

    pageViewedEvent: "[Amplitude] Page Viewed",
    identifyEvent: "$identify",
    elementClickedEvent: "[Amplitude] Element Clicked",

    // SDK-only; stripped from page views.
    pageTitleProperty: "[Amplitude] Page Title",

    // Campaign parser field on autocaptured page views (`document.referrer`).
    pageReferrerProperty: "referrer",
}
